import styled from '@emotion/styled';
import Toolbar from '@material-ui/core/Toolbar';

import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../constants.js/colors';

const drawerWidth = 290;

export const drawerStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        animation: 'fadein 0.5s',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    lowerBar: {
        top: '30px',
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    avatarUSer: {
        color: colors.secondary.white,
        margin: '0px auto',
        alignSelf: 'center',
        width: 38,
        height: 38,
        marginRight: 5,
        background: colors.primary.dark,
        textTransform: 'uppercase',
        fontSize: '1.2rem',
        objectFit: 'cover',
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 18px',
        // necessary for content to be below app bar (match real Toolbar height, not 48px)
        ...theme.mixins.toolbar,
        /* justifyContent: 'space-between', */
        '& p': {
            fontSize: '18px',
            paddingLeft: '24px',
            color: colors.white,
            fontWeight: 'bold',
        },
    },
    content: {
        backgroundColor: colors.gray.main,
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: 0,
        minHeight: '100vh',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    iconMenu: {
        minWidth: 35,
        marginLeft: 5,
        filter: 'brightness(5)',
    },
    activeItem: {
        color: colors.primary.main,
    },
    listItem: {
        '& span': {
            color: 'inherit',
        },
    },
    nested: {
        textDecoration: 'none',
        paddingLeft: theme.spacing(4),
    },
    nameStore: {
        color: '#53627C',
        '& span': {
            marginLeft: '-3px',
        },
    },
    container: {
        [theme.breakpoints.up('sm')]: {
            padding: '32px 24px 136px 24px',
        },
    },
    containerMorePadding: {
        [theme.breakpoints.up('sm')]: {
            padding: '72px 24px 136px 24px',
        },
    },
    titleSubheader: {
        fontFamily: 'DM Sans',
        fontSize: 16,
        transition: '0.5s',
        color: colors.white,
        fontWeight: 'bold',
    },
    listItemText: {
        color: colors.white,
        minWidth: '230px',
        transition: '0.5s',
        '& span': {
            fontFamily: 'DM Sans',
        },
    },
    inactiveForPay: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
    ecometriPlusNavItem: {
        position: 'relative',
        '& .MuiListItemIcon-root, & .MuiListItemText-root': {
            position: 'relative',
            zIndex: 1,
        },
        '& .MuiListItemIcon-root img': {
            width: 24,
            height: 24,
            display: 'block',
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 16,
            right: 16,
            top: 4,
            bottom: 4,
            borderRadius: 10,
            backgroundColor: 'rgba(158, 232, 112, 0.12)',
            border: `1px solid rgba(158, 232, 112, 0.55)`,
            pointerEvents: 'none',
            transition: 'background-color 0.2s ease, border-color 0.2s ease',
        },
        '&:hover::before': {
            backgroundColor: 'rgba(158, 232, 112, 0.2)',
            borderColor: colors.primary.main,
        },
        '&.Mui-selected::before': {
            backgroundColor: 'rgba(158, 232, 112, 0.22)',
            borderColor: colors.primary.main,
        },
        '&.Mui-selected $ecometriPlusLabel': {
            color: colors.primary.main,
        },
    },
    ecometriPlusLabel: {
        fontFamily: 'DM Sans',
        fontWeight: 600,
        color: colors.white,
    },
    ecometriPlusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 6,
        padding: '1px 5px',
        borderRadius: 4,
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '0.05em',
        lineHeight: 1.3,
        backgroundColor: 'rgba(158, 232, 112, 0.25)',
        color: colors.primary.main,
    },
    drawerOpen: {
        backgroundColor: colors.secondary.main,
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: 'hidden',
    },
    drawerClose: {
        backgroundColor: colors.secondary.main,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: '64px',
        },
        MuiListSubheader: {
            display: 'none',
        },
    },
    headerActions: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row-reverse',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'start',
            flexDirection: 'row',
        },
    },
    headerActionsContainerMobile: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        flex: 1,
        gap: '8px',
    },
    renewPlanButton: {
        backgroundColor: colors.error.main,
        color: colors.white,
        padding: '8px',
        fontWeight: '500',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        display: 'flex',
        flex: 1,
        width: '100%',
        justifyContent: 'center',
        textDecoration: 'underline',
    },
}));

export const UserMenu = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;

    .email {
        margin-right: 1rem;
    }
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;

    .btnLink {
        margin-right: 1rem;
    }
`;

export const NotificationContainer = styled.div`
    display: flex;
    align-items: center;
    margin-right: 15px;
    cursor: pointer;

    svg {
        height: 25px;
        width: 25px;
    }

    &:hover svg path {
        fill: ${colors.primary.dark};
    }
`;

export const IconOvalo = styled.img`
    height: 22px;
    margin-right: 14px;
    margin-left: -17px;
    z-index: 99;
    margin-top: -6px;
`;

export const InfoNotification = styled.div`
    position: sticky;
    background: #fcf3ea;
    min-height: 65px;
    ${(props) => (props.isTabletOrMobile ? 'margin-top: 59px' : 'margin-top: 61px')};
    padding: 25px;
`;

export const ContentItems = styled.div`
    overflow: auto;
    max-height: calc(100% - 130px);
    color: ${colors.white};
`;

export const FooterBar = styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;
`;

export const TopBar = styled(Toolbar)`
    background-color: ${colors.white};
    color: black;
`;

export const ContainerFreePlanAlert = styled.div`
    width: 100%;
`;
